module.exports = __webpack_public_path__ + "static/computer3.d27ad8ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/computer3.png
// module id = 502
// module chunks = 195485404593854